<template>
  <div>
    <div class="fullLayout">
      <div v-if="isLogoShow ===''" class="logo">
        <router-link to="/">
          <img alt="Vue logo" :src="require('@/assets/img/logo.png')"  />
        </router-link>
      </div>
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    center: {
      type: Boolean,
      default: false
    },
    isLogoShow: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
  .fullLayout{
    border-radius: 8px;
    overflow: hidden;
    padding: 20px 5px;
    min-height: calc(100vh - 130px);
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .fullLayout:before{
    position: fixed;
    content: '';
    top: 0;
    left: 0;
    background-image: url('../../assets/img/zipImg.png');
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
  }

  .fullLayout .logo {
    max-width: 175px;
    margin: 0px auto 30px;
    position: relative;
    z-index: 1;
  }

</style>
